import { Alert, AlertIcon, AlertTitle, Button, useToast } from "@chakra-ui/react";

type AlertToastProps = {
  status: "info" | "warning" | "error" | "success";
  message: string;
  buttonLabel: string;
  onButtonClick: () => void;
};

export const AlertToast: React.FC<AlertToastProps> = ({ status, message, buttonLabel, onButtonClick }) => (
  <Alert status={status} borderRadius={"lg"}>
    <AlertIcon />
    <AlertTitle>{message}</AlertTitle>
    <Button size="sm" flexShrink={0} ml={2} onClick={onButtonClick}>
      {buttonLabel}
    </Button>
  </Alert>
);

type ShowAlertToastOptions = AlertToastProps & {
  id?: string;
  duration?: number;
};

export const useAlertToast = () => {
  const toast = useToast();
  return ({ id, duration = 5000, ...alertProps }: ShowAlertToastOptions) => {
    if (id && toast.isActive(id)) return;
    toast({
      id,
      duration,
      position: "top",
      render: () => <AlertToast {...alertProps} />,
    });
  };
};
